import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ShieldCheck } from "lucide-react";
import { NeuCard } from "../components/neu/Neu";
import { LangToggle, ThemeToggle } from "../components/controls/Toggles";
import { LegalLinks } from "../features/legal/LegalLinks";
import { SealVerifyResult } from "../features/legal/SealVerifyResult";
import { verifySeal } from "../api/verify";

// صفحة تحقق عامة (بلا تسجيل دخول) يفتحها رمز QR المطبوع على التقرير المختوم.
export default function VerifySealPage() {
  const { t } = useTranslation();
  const { hash } = useParams();
  const [result, setResult] = useState(null);

  useEffect(() => {
    verifySeal(hash)
      .then(setResult)
      .catch(() => setResult({ found: false, hash, status: "unknown" }));
  }, [hash]);

  return (
    <div className="min-h-[100dvh] bg-background px-5 py-8 sm:px-8">
      <div className="mx-auto max-w-2xl">
        <div className="mb-6 flex items-center justify-end gap-2">
          <LangToggle />
          <ThemeToggle />
        </div>
        <NeuCard className="animate-rise-in p-7 sm:p-9" data-testid="verify-seal-page">
          <p className="flex items-center gap-2 text-xs font-bold text-muted-foreground">
            <ShieldCheck className="h-4 w-4 text-primary" /> HELCOO
          </p>
          <h1 className="mt-2 text-3xl font-black tracking-tight sm:text-4xl">{t("verify.title")}</h1>
          <p className="mt-2 text-sm leading-7 text-muted-foreground">{t("verify.intro")}</p>
          <div className="mt-7">
            {!result ? (
              <p className="text-sm text-muted-foreground" data-testid="verify-loading">{t("app.loading")}</p>
            ) : (
              <SealVerifyResult result={result} />
            )}
          </div>
          <div className="mt-9">
            <LegalLinks withLogin />
          </div>
        </NeuCard>
      </div>
    </div>
  );
}
